import React, { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

const RichTextEditor = ({ formData, setFormData, field }) => {
  // ✅ Default HTML content (prevents empty editor)
  const defaultContent = "<p></p>";

  // ✅ Ensure `formData[field]` is always a valid string
  const fieldContent =
    typeof formData?.[field] === "string" ? formData[field].trim() : defaultContent;

  // ✅ Initialize the editor
  const editor = useEditor({
    extensions: [StarterKit],
    content: fieldContent, // ✅ Load content from formData
    onUpdate: ({ editor }) => {
      const newContent = editor.getHTML(); // ✅ Get updated content as HTML
      if (newContent !== formData[field]) {
        setFormData((prevData) => ({
          ...prevData,
          [field]: newContent, // ✅ Save updated content in formData
        }));
      }
    },
  });

  // ✅ Sync content when `formData[field]` updates externally
  useEffect(() => {
    if (editor && editor.getHTML() !== fieldContent) {
      editor.commands.setContent(fieldContent, false);
    }
  }, [formData[field]]); // ✅ Only update when formData[field] changes

  // ✅ Debugging: Log editor content
  useEffect(() => {
    if (editor) {
      //console.log("Editor content:", editor.getHTML());
    }
  }, [editor]);

  return (
    <div className="relative">
      {editor && <EditorContent editor={editor} />}
    </div>
  );
};

export default RichTextEditor;